<template>
    <div>
        <div style="display:flex" class="newRow">
            <h4 style="margin-right: 25px;line-height: 32px;">Media Items</h4>
            <div class="sub Rectangle" style="order: 2;line-height:32px;cursor:pointer"
                @click="showMediaSelectDialog()"><span class="add-button"> + </span> New Items</div>
            <base-button type="link">New Item</base-button>
        </div>

        <div class="newRow newCard">
            <div class="row">
                <div class="col-md-12 description-line">
                    <div class="row description col-sm-12" style="display:flex;justify-content: space-between;">
                        <span class="newText">
                            #1 Super Rear Plus
                        </span>
                        <span>
                            Action <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 description-line">
                    <div class="row description col-sm-12">
                        <div class="col-sm-3">
                            <span>Operator: </span><label>xxxxxxx</label>
                        </div>
                        <div class="col-sm-3">
                            <span>Format: </span><label>xxxxxx</label>
                        </div>
                        <div class="col-sm-2">
                            <span>Internal Code: </span><label>xxxxx</label>
                        </div>
                        <div class="col-sm-2">
                            <span>Subgroup Code: </span><label>xxxx</label>
                        </div>
                        <div class="col-sm-2">
                            <span>Site Code: </span><label>xxxxx</label>
                        </div>

                        <div class="col-sm-12">
                            <div style="display: flex;">

                                <span style="flex-grow: 1; line-height:36px;">Append: </span>
                                <base-input style="flex-grow: 99" disabled>

                                    <el-input disabled></el-input>
                                </base-input>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <el-table border :data="demoList">
                        <!-- <el-table-column type="No." label="No."  width="50"/> -->
                        <!-- <el-table-column prop="invNo" label="Invoice No."  /> -->
                        <el-table-column prop="bonus" label="Bonus" width="70">
                            <template slot-scope="scope">
                                <base-checkbox :v-model="true"></base-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price_option" label="Price Option" min-width="130" />
                        <el-table-column prop="rate_option" label="Rate Option" min-width="130" />
                        <el-table-column prop="unity_qty" label="Unity Qty" min-width="70" />
                        <el-table-column prop="gross_rate_w_cpm" label="Gross Rate(W)/CPM" min-width="130" />
                        <el-table-column prop="qty_imp" label="Qty/IMP" min-width="70">
                        </el-table-column>
                        <el-table-column prop="tbc" label="TBC" min-width="70" />
                        <el-table-column prop="campagin_period" label="Campaign Period" min-width="150">

                        </el-table-column>
                        <el-table-column prop="days" label="Days" min-width="70">

                        </el-table-column>
                        <el-table-column prop="gross_item_sum" label="Gross Item Sum" min-width="150">
                        </el-table-column>
                    </el-table>

                </div>
            </div>
        </div>

        <div class="newRow newCard">
            <div class="row">
                <div class="col-md-12 description-line">
                    <div class="row description col-sm-12" style="display:flex;justify-content: space-between;">
                        <span class="newText">
                            #2 Super Rear Plus
                        </span>
                        <span>
                            Action <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 description-line">
                    <div class="row description col-sm-12">
                        <div class="col-sm-3">
                            <span>Operator: </span><label>xxxxxxx</label>
                        </div>
                        <div class="col-sm-3">
                            <span>Format: </span><label>xxxxxx</label>
                        </div>
                        <div class="col-sm-2">
                            <span>Internal Code: </span><label>xxxxx</label>
                        </div>
                        <div class="col-sm-2">
                            <span>Subgroup Code: </span><label>xxxx</label>
                        </div>
                        <div class="col-sm-2">
                            <span>Site Code: </span><label>xxxxx</label>
                        </div>

                        <div class="col-sm-12">
                            <div style="display: flex;">

                                <span style="flex-grow: 1; line-height:36px;">Append: </span>
                                <base-input style="flex-grow: 99" disabled>

                                    <el-input disabled></el-input>
                                </base-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <el-table border :data="demoList">
                        <!-- <el-table-column type="No." label="No."  width="50"/> -->
                        <!-- <el-table-column prop="invNo" label="Invoice No."  /> -->
                        <el-table-column prop="bonus" label="Bonus" width="70">
                            <template slot-scope="scope">
                                <base-checkbox :v-model="true"></base-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price_option" label="Price Option" min-width="130" />
                        <el-table-column prop="rate_option" label="Rate Option" min-width="130" />
                        <el-table-column prop="unity_qty" label="Unity Qty" min-width="70" />
                        <el-table-column prop="gross_rate_w_cpm" label="Gross Rate(W)/CPM" min-width="130" />
                        <el-table-column prop="qty_imp" label="Qty/IMP" min-width="70">
                        </el-table-column>
                        <el-table-column prop="tbc" label="TBC" min-width="70" />
                        <el-table-column prop="campagin_period" label="Campaign Period" min-width="150">

                        </el-table-column>
                        <el-table-column prop="days" label="Days" min-width="70">

                        </el-table-column>
                        <el-table-column prop="gross_item_sum" label="Gross Item Sum" min-width="150">
                        </el-table-column>
                    </el-table>

                </div>
            </div>
        </div>
        <el-dialog title="Media Select" v-model="mediaSelectDialogShow" :close-on-press-escape="false" :close-on-click-modal="false">
            <div style="margin-right: 30px;">
                <div style="display:flex"  >
                    <h4 style="margin-right: 25px;line-height: 32px;">Tier</h4>
                </div>
                <div style="display: flex">
                    <div class="groupButtonBus">Bus</div>
                    <div class="groupButtonOutdoor">Outdoor</div>
                    <div class="groupButtonMtr">MTR</div>
                </div>

                <div style="display:flex"  >
                    <h4 style="margin-right: 25px;line-height: 32px;">City</h4>
                </div>
                <base-input  >
                    <el-select v-model="selectedCity" class="select-primary" size="large" 
                    filterable multiple >
                        <el-option v-for="option in  [{id:'xxxxx', code: 'ccccccc', name: 'Hong Kong'}]" class="select-primary"
                            :value="option.id" :label="option.name" :key="option.id">
                        </el-option>
                    </el-select>
                </base-input>

                <div style="display:flex"  >
                    <h4 style="margin-right: 25px;line-height: 32px;">Location/Operator</h4>
                </div>
                <base-input  >
                    <el-select v-model="selectedLocation" class="select-primary" size="large" 
                    filterable multiple >
                        <el-option v-for="option in  [{id:'kmb', code: 'kmb', name: 'KMB'},{id:'lwb', code: 'lwb', name: 'LWB'}]" class="select-primary"
                            :value="option.id" :label="option.name" :key="option.id">
                        </el-option>
                    </el-select>
                </base-input>

                <div style="display:flex"  >
                    <h4 style="margin-right: 25px;line-height: 32px;">Format</h4>
                </div>
                <base-input  >
                    <el-select v-model="selectedFormat" class="select-primary" size="large" 
                    filterable multiple >
                        <el-option v-for="option in  [{id:'xxx', code: 'kmb', name: 'xxx'},{id:'xxxxx', code: 'lwb', name: 'xxxxx'}]" class="select-primary"
                            :value="option.id" :label="option.name" :key="option.id">
                        </el-option>
                    </el-select>
                </base-input>

                <div style="display:flex"  >
                    <h4 style="margin-right: 25px;line-height: 32px;">Media</h4>
                </div>
                <div style="position: relative;">

                    <base-input  style="width: 100%;">
                        <el-select v-model="selectedMedia" class="select-primary" size="large" 
                        filterable multiple >
                            <el-option v-for="option in  [{id:'MDA75942', code: 'kmb', name: 'MDA75942-KMB-Arrow_BBA'}, {id:'MDA75888', code: 'lwb', name: 'MDA75888-KMB-Arrow_BBA'}]" class="select-primary"
                                :value="option.id" :label="option.name" :key="option.id">
                            </el-option>
                        </el-select>
                    </base-input>
                    <div style=" line-height: 36px;position: absolute;right: -27px;top:5px">
                        <span  style="background-color: #eb6100;" class="add-button" >+</span>
                    </div>
                </div>

                <div style="display:flex"  >
                    <h4 style="margin-right: 25px;line-height: 32px;">Selected Media</h4>
                </div>
                <div  style=" height: 300px; overflow-y:scroll;">
                    <div class="newCardNoPadding">
                        <div style="border-bottom: 1px solid #e3e3e3; padding: 11px 11px 5px 11px;display:flex;justify-content: space-between;" >
                            <div    >MDA75942 - Arrow</div>   
                            <div  style="background-color: #979797;" class="add-button" >-</div>
                        </div>

                        <div style="padding: 11px 11px 0px 11px;" >
                            <div class="row">
    
                                <div class="col-md-12 description-line">
                                    <div class="row description col-sm-12" style="color: #423022;">
                                        <div class="col-sm-2">
                                            <span >Format: </span><label>Arrow</label>
                                        </div>
                                        <div class="col-sm-3">
                                            <span>Internal Code: </span><label>KBM_BBA_AR</label>
                                        </div>
                                        <div class="col-sm-4" style="color: #4ab45f; ">
                                           4 Weeks Standard (HKD$5,100/4 Weeks) <i class="el-icon-arrow-down el-icon--right"></i>
                                        </div>
                                        <div class="col-sm-3">
                                            <span>Qty: </span><span style="text-align: right; width: 60px;
                                                                    height: 32px;
                                                                    margin: 10px 13.5px 0 9px;
                                                                    padding: 6px 15px 6px 41px;
                                                                    border-radius: 6px;
                                                                    border: solid 1px #543d2c;
                                                                    background-color: #fff;">1</span>
                                        </div>
                                      

                                        <div class="col-sm-2">
                                            <span>Operator: </span><label>KMB</label>
                                        </div>
                                        <div class="col-sm-10">
                                            <span style="color: #eb6100; width: 40px;
                                                            height: 26px;
                                                            padding: 5px 9px 4px 9px;
                                                            border-radius: 26px;
                                                            background-color: #ffece7;">360</span>
                                        </div>
                                      
                                        <div class="col-sm-12">
                                            <span>Reamrk: </span><label></label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="newCardNoPadding">
                        <div style="border-bottom: 1px solid #e3e3e3; padding: 11px 11px 5px 11px;display:flex;justify-content: space-between;" >
                                <div>MDA75942 - Arrow</div>   
                                <div  style="background-color: #979797;" class="add-button" >-</div>
                        </div>

                        <div style="padding: 11px 11px 0px 11px;" >
                            <div class="row">
    
                                <div class="col-md-12 description-line">
                                    <div class="row description col-sm-12" style="color: #423022;">
                                        <div class="col-sm-2">
                                            <span >Format: </span><label>Arrow</label>
                                        </div>
                                        <div class="col-sm-3">
                                            <span>Internal Code: </span><label>KBM_BBA_AR</label>
                                        </div>
                                        <div class="col-sm-4" style="color: #4ab45f; ">
                                           4 Weeks Standard (HKD$5,100/4 Weeks) <i class="el-icon-arrow-down el-icon--right"></i>
                                        </div>
                                        <div class="col-sm-3">
                                            <span>Qty: </span><span style="text-align: right; width: 60px;
                                                                    height: 32px;
                                                                    margin: 10px 13.5px 0 9px;
                                                                    padding: 6px 15px 6px 41px;
                                                                    border-radius: 6px;
                                                                    border: solid 1px #543d2c;
                                                                    background-color: #fff;">1</span>
                                        </div>
                                      

                                        <div class="col-sm-2">
                                            <span>Operator: </span><label>KMB</label>
                                        </div>
                                        <div class="col-sm-10">
                                            <span style="color: #eb6100; width: 40px;
                                                            height: 26px;
                                                            padding: 5px 9px 4px 9px;
                                                            border-radius: 26px;
                                                            background-color: #ffece7;">360</span>
                                        </div>
                                      
                                        <div class="col-sm-12">
                                            <span>Reamrk: </span><label></label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="newCardNoPadding">
                        <div style="border-bottom: 1px solid #e3e3e3; padding: 11px 11px 5px 11px;display:flex;justify-content: space-between;" >
                                <div    >MDA75942 - Arrow</div>   
                                <div  style="background-color: #979797;" class="add-button" >-</div>
                        </div>

                        <div style="padding: 11px 11px 0px 11px;" >
                            <div class="row">
    
                                <div class="col-md-12 description-line">
                                    <div class="row description col-sm-12" style="color: #423022;">
                                        <div class="col-sm-2">
                                            <span >Format: </span><label>Arrow</label>
                                        </div>
                                        <div class="col-sm-3">
                                            <span>Internal Code: </span><label>KBM_BBA_AR</label>
                                        </div>
                                        <div class="col-sm-4" style="color: #4ab45f; ">
                                           4 Weeks Standard (HKD$5,100/4 Weeks) <i class="el-icon-arrow-down el-icon--right"></i>
                                        </div>
                                        <div class="col-sm-3">
                                            <span>Qty: </span><span style="text-align: right; width: 60px;
                                                                    height: 32px;
                                                                    margin: 10px 13.5px 0 9px;
                                                                    padding: 6px 15px 6px 41px;
                                                                    border-radius: 6px;
                                                                    border: solid 1px #543d2c;
                                                                    background-color: #fff;">1</span>
                                        </div>
                                      

                                        <div class="col-sm-2">
                                            <span>Operator: </span><label>KMB</label>
                                        </div>
                                        <div class="col-sm-10">
                                            <span style="color: #eb6100; width: 40px;
                                                            height: 26px;
                                                            padding: 5px 9px 4px 9px;
                                                            border-radius: 26px;
                                                            background-color: #ffece7;">360</span>
                                        </div>
                                      
                                        <div class="col-sm-12">
                                            <span>Reamrk: </span><label></label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    

                  

                </div>
                <div style="display:flex"  >
                    <h4 style="margin-right: 25px;line-height: 32px;">Campaign Date</h4>
                </div>
                <div style="display:flex">
                    <div style="col-sm-10">
                        <el-date-picker
                        v-model="value2"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer" >
                <div style="margin-right: 30px;">
                    <base-button  type="primary" @click="saveEditAddress(editAddressForm.index)" >OK</base-button>
                    <base-button  @click="mediaSelectDialogShow = false">Close</base-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script setup>
    import baseInput from "@/components/newUI/Inputs/BaseInput";
    import baseButton from "@/components/newUI/BaseButton";
    import baseRadio from "@/components/newUI/Inputs/BaseRadio";
    import { nextTick, ref } from 'vue';
    var mediaSelectDialogShow = ref(false);
    const showMediaSelectDialog = async () => {
        mediaSelectDialogShow.value = true
        await nextTick();
    };
</script>
